<div class="d-flex gap-1 flex-column">
  <ng-container *ngIf="userId; else systemTemp">
    <div class="d-flex gap-1 align-items-center flex-wrap">
      <span class="badge bg-light text-dark border p-1"
        ><i class="feather icon-user"></i
      ></span>
      <strong>{{ displayName }}</strong>
      <span class="text-muted text-small w-100">({{ userId }})</span>
    </div>
  </ng-container>

  <ng-template #systemTemp>
    <div class="d-flex gap-1">
      <span class="badge bg-light text-dark border p-1">🤖</span>
      <strong class="align-content-center">{{ systemName }}</strong>
    </div>
  </ng-template>

  <span class="text-small">
    {{ timestamp | relativeTime }}
  </span>
</div>
